import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Users";
import getToken from "app/api/getToken";
import { IUserResponse } from "app/api/types";

export const GET_USER_PROFILE_REQUEST = "GET_USER_PROFILE_REQUEST";
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL";

export const getUserProfile = () => (dispatch: any): any => {
  dispatch({ type: GET_USER_PROFILE_REQUEST });

  const token = getToken();

  return api
    .getUserProfile(token)
    .then((response: AxiosResponse) => {
      const user: IUserResponse = get(response, "data.data", {});
      dispatch({ type: GET_USER_PROFILE_SUCCESS, payload: user });

      return user;
    })
    .catch(err => {
      dispatch({
        type: GET_USER_PROFILE_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
